import { checkKeyValid } from "@/utils/globalConfigs";
import { mapState, mapMutations } from "vuex";

export default () => {
  const computed ={
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    })
  };

  const methods = {
    ...mapMutations("account", {
      setGlobalConfigs: "SET_GLOBAL_CONFIGS",
    }),
    isKeyValid(key) {
      if (typeof this.shopInfo.globalConfigs == "string") {
        const globalConfigs = JSON.parse(this.shopInfo.globalConfigs);
        this.setGlobalConfigs(globalConfigs);
      }
      return checkKeyValid(key, this.shopInfo.shopifyDomain, this.shopInfo.globalConfigs)
    }
  };

  const output = {
    computed,
    methods,
  };

  return output;
};
